import Api from '@sancare/typescript-commons/src/misc/api'

import { convertHomeChartStatsOut, convertHomeStatsOut } from '@/home/store/dto'
import { state } from '@/home/store/state'
import { HomeChartStatsPayload, HomeStatsPayload } from '@/home/types'

export const actions = {
  getHomeStats({ commit }, payload: HomeStatsPayload) {
    return Api.request(
      state.requests.getHomeStats,
      {
        urlParams: convertHomeStatsOut(payload),
        successMut: 'getHomeStatsSuccess',
        errorMut: 'getHomeStatsError',
      },
      commit
    )
  },
  getHomeChartStats({ commit }, payload: HomeChartStatsPayload) {
    return Api.request(
      state.requests.getHomeChartStats,
      {
        urlParams: convertHomeChartStatsOut(payload),
        successMut: 'getHomeChartStatsSuccess',
        errorMut: 'getHomeChartStatsError',
      },
      commit
    )
  },
  getPredictionModels({ commit }) {
    return Api.request(
      state.requests.getPredictionModels,
      {
        successMut: 'getPredictionModelsSuccess',
        errorMut: 'getPredictionModelsError',
      },
      commit
    )
  },
}
